export interface ProductInfoItem {
  id?: string;
  secondaryPackingId?: string;
  description?: string;
  declarationDescription?: string;
  unitPrice?: number;
  totalNumberPcs?: number;
}

export interface RemarkItem {
  remark?: string;
  value?: string;
}

export type OverUnderageStatus =
  | "OVERDELIVERY"
  | "UNDERDELIVERY"
  | "ALL"
  | "NONE";

export function isOverUnderageBlocked(
  status?: OverUnderageStatus | null
): boolean {
  return (
    status === "OVERDELIVERY" ||
    status === "UNDERDELIVERY" ||
    status === "ALL"
  );
}

export class CustomsPackingItem {
  id: string;
  hqPackingListId: string;
  code: string;
  overUnderageStatus?: OverUnderageStatus;
  grossWeight: string;
  netWeight: string;
  volume: string;
  totalAmount: string;
  totalProductQuantity: number;
  totalSecondaryCtnQuantity: number;
  productInfoItems: ProductInfoItem[] = [];
  configuredContainerId: string;
  selected: boolean;
  select: boolean;
  selectable: boolean;
  groupId: string;
  customsPackingChildernItems: CustomsPackingItem[];
  containerTypeCode: string;
  containerNumber: string;
}

export class HqPackingListItem {
  id: string;
  parentId: string;
  factoryName: string;
  code: string;
  remark: RemarkItem[];
  pltCount: string;
  ctnCount: string;
  totalProductQuantity: number;
  totalSecondaryCtnQuantity: number;
  customsPackingItems: CustomsPackingItem[] = [];
  toggleSelection: any;
}

export class ContainerInfoModel {
  id: string;
  containerNumber: string;
  containerTypeCode: string;
  loadingInOneOrMorePlaces: boolean;
  name: string;
  sealNumber: string;
  value: string;
  volume: string;
  remark: string;
}
